/**
 * GA4 (gtag.js) loader. Injected from JS rather than pasted into
 * public/index.html so the tag is simply absent when REACT_APP_GA_ID isn't set
 * (local dev, QA) instead of requesting a script with an unresolved
 * placeholder ID.
 *
 * Route changes need no code here: GA4's Enhanced Measurement picks up
 * react-router's history.pushState calls. Keep "Page changes based on browser
 * history events" enabled on the property, and don't also send page_view
 * manually or every navigation gets counted twice.
 */
const GA_ID = process.env.REACT_APP_GA_ID;

export function initAnalytics(): void {
  if (!GA_ID || typeof window === 'undefined') return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(script);

  const w = window as any;
  const dataLayer = (w.dataLayer = w.dataLayer || []);
  // gtag.js reads the raw `arguments` object off the queue, so this can't be
  // written as a rest-parameter function pushing an array.
  const gtag: (...args: unknown[]) => void = function () {
    dataLayer.push(arguments);
  };
  w.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_ID);
}
